import React, { useContext, useEffect } from "react"
import { Modal } from "react-bootstrap";
import { Button, InputLabel, TextField, MenuItem, Select } from "@mui/material";
import language from "../../../nls/language.json";
import Context from "../../../context/Context";
import '../Combinations.css';

export default function EditPieceModal({
  ShowModalEdit,
  setShowModalEdit,
  handleAddPieces,
  selectedPieces,
  grupoPecas,
  putPieces,
  checkSaveBtn
}) {
  const {
    selectedCountry,
  } = useContext(Context);
  
  return (
    <Modal show={ShowModalEdit} onHide={() => setShowModalEdit(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.editarPeca.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-row">
          <InputLabel className="d-flex flex-column me-1 w-50">
            {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.editarPeca.labels.peca}
            <TextField
              className="mb-3"
              name="pecaGrupo_CodPeca"
              required
              fullWidth
              id="outlined-basic"
              placeholder="Código da Peça"
              value={selectedPieces.pecaGrupo_CodPeca}
              onChange={({ target }) => handleAddPieces(target, "EDIT_PECA")}
            />
          </InputLabel>

          <InputLabel
            className="d-flex flex-column me-1 w-50"
          >
            {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.editarPeca.labels.grupo}
            <Select
              className=""
              value={selectedPieces.pecaGrupo_Nome}
              onChange={({ target }) => {
                handleAddPieces({
                  name: "pecaGrupo_Nome",
                  value: target.value
                }, "EDIT_PECA")
              }}
            >
              {grupoPecas.map((itemProd, i) => (
                <MenuItem
                  key={`grupPiece-${itemProd.prodGrupo_GrupoNome}-${i}`}
                  value={itemProd.prodGrupo_GrupoNome}
                >
                  {itemProd.prodGrupo_GrupoNome}
                </MenuItem>
              ))}
            </Select>
          </InputLabel>

        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="text"
          sx={{ marginRight: 2 }}
          onClick={() => setShowModalEdit(false)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.editarPeca.btnCancelar}
        </Button>
        <Button
          variant="contained"
          onClick={() => putPieces(selectedPieces)}
          disabled={checkSaveBtn(selectedPieces)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.editarPeca.btnSalvar}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

